import { useEffect } from "react";

/**
 * Wire IntersectionObserver to auto-add `.is-visible` on any element that
 * carries `data-reveal`. Pair with the CSS rules in App.css for a smooth
 * fade + slide-up on scroll.
 *
 * Usage: call `useReveal()` once at the top of a page component. Then any
 * child with `<div data-reveal data-delay="2">…</div>` will animate in as it
 * enters the viewport.
 */
export default function useReveal(rootSelector) {
  useEffect(() => {
    const root = rootSelector ? document.querySelector(rootSelector) : document;
    if (!root) return;
    const targets = root.querySelectorAll("[data-reveal]:not(.is-visible)");
    if (!targets.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("is-visible");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    targets.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [rootSelector]);
}
